import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	gap: 10px;
`;

/*
	font-feature-settings: "tnum";
	font-variant-numeric: tabular-nums;
*/

const StyledIndexLabel = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 30px;
	padding: 0 10px;
	border-radius: 10px;
	background: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledSpan = styled.span`
	font-weight: 400;
	font-size: 14px;
	opacity: 0.5;
`;

export { StyledContainer, StyledIndexLabel, StyledSpan };
